import React from 'react';
import "../../css/frontend/open-calls-view.css";
import dynamicAPI from '../../api/dynamicAPI';
import {useQuery} from 'react-query';
import OpenCallsList from "../../components/view/open-calls/opencalls-list";
import OpenCallsForm from "../../components/view/open-calls/opencalls-form";
import {useTranslation} from "react-i18next";
import { Helmet } from 'react-helmet-async';

function OpenCallsView() {
    const url = '/api/view/opencalls';
    const q = '';
    const queryKey = 'open_calls';
    const {data: openCallsData, error: eventsError} = useQuery(
        queryKey,
        async () =>
            await dynamicAPI('get', `${url}?page=1&q=${q}&limit=1000`, {}),
        {retry: 0}
    );
    const { t } = useTranslation();

    // console.log('heyu');

    // console.log(eventsData);

    // console.log(spacesData);

    // Check if the data has been fetched successfully
    if (eventsError) {
        return <div>Error: {eventsError.message}</div>;
    }

    if (!openCallsData || !Array.isArray(openCallsData.data)) {
        return <div>No events found.</div>;
    }
    return (
        <>
            <Helmet>
                <title>Discover Open Calls | ArtNet</title>
                <meta
                    name="description"
                    content="Stay updated with the latest open calls for artists or submit yours."
                />
                <meta property="og:title" content="Open Calls for Artists" key="ogtitle" />
                <meta
                    property="og:description"
                    content="Stay updated with the latest open calls for artists or submit yours."
                    key="ogdesc"
                />
                <meta property="og:url" content="https://aart.gr/open-calls" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <div className="open-calls-block" style={{ width: '100%'}}>
                    <OpenCallsList
                        openCallsData={openCallsData}
                        t={t}
                    />
                    <OpenCallsForm
                        t={t}
                    />
            </div>
        </>
    );
}

export default OpenCallsView;